/* ══════════════════════════════════════════════════════════════════════════
   CASEMIRA, LA PAGE GUIDE DES TAILLES : LES ONGLETS ET LA BARRE COLLANTE
   assets/casemira-guide-page.js                       G15, puis G18e 08/09/26
   ══════════════════════════════════════════════════════════════════════════

   CE QU'IL FAIT, ET AUCUNE LIGNE N'EST NECESSAIRE A LA LECTURE :
     1. il fait de la barre collante une VRAIE barre d'onglets : roles ARIA,
        `aria-selected`, tabindex tournant, fleches gauche / droite, Home et
        End ;
     2. il ouvre un panneau et ferme les dix autres, ecrit le type dans
        l'adresse, et suit le bouton « precedent » du navigateur ;
     3. il fait glisser le panneau sous le doigt, au telephone, pour passer au
        type suivant ou precedent ;
     4. il pose sous le panneau deux fleches « precedent » et « suivant » ;
     5. il fait glisser le jeton surligne dans la piste, ou la rangee de onze
        jetons ne tient pas dans 390 px, et voile le bord du cote ou il reste
        des jetons a voir ;
     6. il dit a `<html>` que la barre est COLLEE, pour que la feuille sache
        quand faire apparaitre « Retour en haut » et quand suivre le retrait de
        l'en-tete du theme ;
     7. il rouvre ou referme la grille de choix quand la LARGEUR change, et la
        laisse tranquille des que le visiteur y a touche ;
     8. il ouvre les replis a l'impression, et les referme apres.

   CE QU'IL NE FAIT PAS, ET C'EST LE POINT DE TOUT LE LOT : IL N'OUVRE PAS LE
   PREMIER PANNEAU. Cela se passe AVANT lui, dans le script en ligne de la
   section, qui pose deux attributs sur `<html>` pendant l'analyse du document,
   et dans `casemira-guide-page.css`, qui decide a partir d'eux lequel des onze
   panneaux s'affiche. Charge en `defer`, ce fichier-ci arrive APRES la
   premiere peinture : y masquer dix sections, ce serait retirer dix mille
   pixels de page sous les yeux du visiteur, c'est-a-dire fabriquer le pire
   decalage de mise en page que cette page puisse produire. Il arrive donc sur
   une page deja juste, et il n'y ajoute que du comportement.

   SANS LUI, LA PAGE MARCHE. Les onze onglets restent des ancres ; le script en
   ligne ecoute `hashchange` et change le panneau tout seul ; « Retour en
   haut » reste un lien vers `#cmpg-haut` ; et toutes les phrases de la page
   sont deja ecrites par le serveur. Il ne fabrique aucun texte : les deux
   seuls mots qu'il pose (« Precedent », « Suivant ») sont lus dans deux
   attributs `data-t-*` que Liquid a remplis depuis les fichiers de locale.

   IL NE TOUCHE PAS AUX ONZE MOTEURS. `casemira-guide-tailles.js` et
   `casemira-guide-tiroir.js` dessinent les scenes ; ce fichier ne lit ni ne
   modifie un seul de leurs noeuds, et n'a pas a leur demander de redessiner
   quand un panneau s'ouvre : leurs SVG portent un `viewBox` fixe et leurs
   cotes sont posees en POURCENTAGE, donc un dessin fait dans une boite de
   zero pixel est juste des que la boite en fait mille. Les trois scripts
   n'ont aucun symbole en commun et peuvent arriver dans n'importe quel ordre.

   POURQUOI L'INTERSECTIONOBSERVER DE G15 A DISPARU. Il surlignait, dans la
   barre, la section qu'on etait en train de lire : il fallait un observateur
   parce que la page deroulait onze sections et que la barre devait suivre
   l'oeil. Il n'y a plus qu'un panneau a l'ecran : le jeton surligne est celui
   qu'on vient de choisir, il n'y a plus rien a observer, et la page a un
   observateur de moins sur le fil principal.

   Autorite : DESIGN.md a la racine. Aucune duree ecrite ici : le mouvement
   vit dans la feuille, sous `prefers-reduced-motion`.
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var racine = document.documentElement;
  var barre = document.querySelector('[data-cmpg-barre]');
  var piste = document.querySelector('[data-cmpg-piste]');
  if (!barre || !piste) return;

  var jetons = Array.prototype.slice.call(piste.querySelectorAll('[data-cmpg-vers]'));
  var sections = Array.prototype.slice.call(document.querySelectorAll('[data-cmpg-type]'));
  if (!jetons.length || !sections.length) return;

  var parId = {};
  var panneauDe = {};
  var i;
  for (i = 0; i < jetons.length; i++) parId[jetons[i].getAttribute('data-cmpg-vers')] = jetons[i];
  for (i = 0; i < sections.length; i++) panneauDe[sections[i].getAttribute('data-cmpg-type')] = sections[i];

  var cartes = {};
  var lesCartes = document.querySelectorAll('.cmpg-carte[data-cmpg-vers]');
  for (i = 0; i < lesCartes.length; i++) cartes[lesCartes[i].getAttribute('data-cmpg-vers')] = lesCartes[i];

  var doux = !window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var doigt = !!window.matchMedia && window.matchMedia('(pointer: coarse)').matches;

  /* ── 0. L'ORDRE ET LES FAMILLES, LUS LA OU LE SERVEUR LES A ECRITS ───────
     `data-cmpg-carte` porte les trois listes dans l'ordre, chacune avec sa
     famille : « piece:salon,sam,... ;forme:rond,ovale ;mesure:couloir,... ».
     Le script en ligne de la section lit la MEME chaine, au meme endroit :
     l'ordre des onglets, celui des panneaux et celui du glissement ne peuvent
     pas diverger, parce qu'il n'y en a qu'un. */
  var ordre = [];
  var famille = {};
  (function () {
    var groupes = (barre.getAttribute('data-cmpg-carte') || '').split(';');
    for (var g = 0; g < groupes.length; g++) {
      var p = groupes[g].split(':');
      var ids = (p[1] || '').split(',');
      for (var k = 0; k < ids.length; k++) {
        if (ids[k] && parId[ids[k]] && panneauDe[ids[k]]) { famille[ids[k]] = p[0]; ordre.push(ids[k]); }
      }
    }
  })();
  /* REPLI : si l'attribut manque ou ne dit rien d'utilisable, on prend l'ordre
     du document. Une barre d'onglets sans ordre serait une barre qui ne sait
     pas ce qu'est « le suivant ». */
  if (!ordre.length) {
    for (i = 0; i < sections.length; i++) {
      var id0 = sections[i].getAttribute('data-cmpg-type');
      if (parId[id0]) ordre.push(id0);
    }
  }
  if (!ordre.length) return;
  var rang = {};
  for (i = 0; i < ordre.length; i++) rang[ordre[i]] = i;

  var courant = racine.getAttribute('data-cmpg-actif');
  if (!(courant in rang)) courant = ordre[0];

  /* ══════════════════════════════════════════════════════════════════════
     1. LES ROLES D'ONGLETS SONT POSES ICI, ET NULLE PART AILLEURS
     ----------------------------------------------------------------------
     LE HTML SERVI NE LES PORTE PAS, ET C'EST DELIBERE. Annoncer un `tablist`
     dans le document, ce serait promettre a un lecteur d'ecran un widget que
     la page n'a pas quand ce fichier ne tourne pas : onze onglets dont aucun
     ne se selectionne, onze panneaux tous ouverts en meme temps. Les roles
     arrivent avec le comportement qu'ils decrivent, pas avant.

     PAS D'`aria-label` SUR LE `tablist` : le `<nav>` qui l'entoure en porte
     un, et deux noms pour la meme rangee, c'est le nom lu deux fois.

     TABINDEX TOURNANT : un seul onglet dans le parcours de tabulation, les
     dix autres a `-1`. C'est ce qui fait qu'une tabulation traverse la barre
     en un coup au lieu de onze, et que les fleches sont le seul moyen d'aller
     d'un onglet a l'autre, comme dans tout systeme d'onglets.
     ══════════════════════════════════════════════════════════════════════ */
  piste.setAttribute('role', 'tablist');
  for (i = 0; i < piste.children.length; i++) {
    if (!piste.children[i].hasAttribute('aria-hidden')) piste.children[i].setAttribute('role', 'presentation');
  }
  for (i = 0; i < jetons.length; i++) {
    var jid = jetons[i].getAttribute('data-cmpg-vers');
    jetons[i].setAttribute('role', 'tab');
    jetons[i].id = 'cmpg-tab-' + jid;
    if (panneauDe[jid]) jetons[i].setAttribute('aria-controls', panneauDe[jid].id || ('gt-' + jid));
    /* `aria-current` disait « la section que vous lisez » quand la page les
       deroulait toutes ; `aria-selected` dit « l'onglet retenu ». Les deux sur
       le meme noeud, c'est la meme chose annoncee deux fois. Le retrait vit
       dans `marqueBarre`, qui repasse a chaque bascule : ecrit ici seulement,
       il ne rattrapait pas le `aria-current` que le script en ligne repose sur
       un retour arriere du navigateur. */
  }
  for (i = 0; i < sections.length; i++) {
    var sid = sections[i].getAttribute('data-cmpg-type');
    if (!parId[sid]) continue;
    sections[i].setAttribute('role', 'tabpanel');
    sections[i].setAttribute('aria-labelledby', 'cmpg-tab-' + sid);
    /* Le panneau est atteignable au clavier : apres les onglets, la tabulation
       entre DANS le panneau au lieu de sauter par-dessus lui. */
    sections[i].setAttribute('tabindex', '0');
  }

  /* ── 2. LES DEUX FLECHES SONT RENDUES PAR LE SERVEUR, ON NE FAIT QUE LES
     REMPLIR. Les fabriquer ici les faisait apparaitre APRES la premiere
     peinture et poussait le recapitulatif de quatre-vingts pixels : 0,0296 de
     decalage de mise en page au 1440, mesure par la recette. Leur boite est
     donc dans le HTML servi, vide et reservee, et ce fichier n'y ecrit que
     deux noms et deux adresses, qui ne changent aucune hauteur.

     LES DEUX MOTS DE SENS SONT DEJA LA, ecrits par Liquid depuis les fichiers
     de locale. Le nom du type voisin est COPIE de son propre onglet. Ce
     fichier ne traduit rien et n'invente aucune chaine. */
  var navP = document.querySelector('[data-cmpg-fleche="p"]');
  var navS = document.querySelector('[data-cmpg-fleche="s"]');
  brancheFleche(navP, 'ar');
  brancheFleche(navS, 'av');
  function brancheFleche(a, sens) {
    if (!a) return;
    a.addEventListener('click', function (e) {
      var vers = a.getAttribute('data-cmpg-vers');
      if (!vers) return;
      e.preventDefault();
      ouvre(vers, { sens: sens, defile: true });
    });
  }
  function majFleches(id) {
    var n = rang[id];
    ecris(navP, ordre[n - 1]);
    ecris(navS, ordre[n + 1]);
    /* LES DEUX FLECHES RESTENT DANS LA MISE EN PAGE AUX DEUX BOUTS. C'est
       `visibility`, jamais `display` : sur le premier et le dernier type, la
       rangee garderait sinon une seule fleche large de toute la page, et la
       ligne changerait de forme d'un panneau a l'autre. */
    function ecris(el, vers) {
      if (!el) return;
      if (!vers || !parId[vers]) {
        el.removeAttribute('data-cmpg-vers');
        el.removeAttribute('href');
        el.style.visibility = 'hidden';
        el.setAttribute('aria-hidden', 'true');
        el.setAttribute('tabindex', '-1');
        return;
      }
      el.setAttribute('data-cmpg-vers', vers);
      el.setAttribute('href', '#gt-' + vers);
      el.style.visibility = '';
      el.removeAttribute('aria-hidden');
      el.removeAttribute('tabindex');
      var nom = el.querySelector('.cmpg-nav__n');
      if (nom) nom.textContent = (parId[vers].textContent || '').trim();
    }
  }

  /* ══════════════════════════════════════════════════════════════════════
     3. OUVRIR UN PANNEAU
     ----------------------------------------------------------------------
     TOUT SE JOUE SUR DEUX ATTRIBUTS DE `<html>`, exactement les deux que le
     script en ligne a poses avant la premiere peinture. La feuille fait le
     reste : c'est elle qui sait quel panneau montrer, quel titre de famille
     garder, et dans quel sens le panneau entre. Ce fichier ne pose ni
     `hidden`, ni `style.display`, sur aucune section.

     `data-cmpg-sens` EST POSE AVANT `data-cmpg-actif`, et l'ordre compte : le
     navigateur rejoue l'animation d'un element qui redevient affiche, et il
     doit connaitre le sens au moment ou il la choisit.

     L'ADRESSE SUIT, EN `replaceState` ET PAS EN `pushState`. Onze pieces
     visitees, ce serait onze pressions sur « precedent » avant de sortir de la
     page : le bouton retour du navigateur cesserait de faire ce qu'il promet.
     L'adresse reste copiable et rechargeable, ce qui est tout ce qu'on lui
     demande.
     ══════════════════════════════════════════════════════════════════════ */
  function ouvre(id, opts) {
    if (!(id in rang)) return;
    opts = opts || {};
    var avant = courant;
    if (id !== avant) {
      var sens = opts.sens || (rang[id] > rang[avant] ? 'av' : 'ar');
      racine.setAttribute('data-cmpg-sens', sens);
      racine.setAttribute('data-cmpg-actif', id);
      racine.setAttribute('data-cmpg-fam', famille[id] || '');
      courant = id;
    }
    marqueBarre(id);
    majFleches(id);
    if (opts.adresse !== false) ecrisAdresse(id);
    if (opts.defile) defileVers(id);
    if (opts.focus && parId[id]) parId[id].focus();
  }

  /* `aria-current` EST RETIRE A CHAQUE PASSAGE, PAS SEULEMENT A L'ARMEMENT
     (revue G18e). Le script en ligne de la section le pose, et c'est voulu :
     sans le fichier differe, il est le SEUL marqueur annonce, et il suit
     `hashchange` tout seul. Mais des que ce fichier-ci tourne, `aria-selected`
     dit deja la meme chose, et un retour arriere du navigateur reveillait les
     deux ecouteurs : le script en ligne reposait `aria-current`, et l'onglet
     se retrouvait annonce deux fois. On nettoie donc a chaque marquage, pas
     une seule fois au demarrage. */
  function marqueBarre(id) {
    for (var k = 0; k < jetons.length; k++) {
      var v = jetons[k].getAttribute('data-cmpg-vers');
      var on = v === id;
      jetons[k].classList.toggle('is-on', on);
      jetons[k].removeAttribute('aria-current');
      jetons[k].setAttribute('aria-selected', on ? 'true' : 'false');
      jetons[k].setAttribute('tabindex', on ? '0' : '-1');
      if (cartes[v]) cartes[v].classList.toggle('is-on', on);
    }
    if (parId[id]) amene(parId[id]);
  }

  function ecrisAdresse(id) {
    if (!window.history || !window.history.replaceState) return;
    try {
      window.history.replaceState(window.history.state, '', '#gt-' + id);
    } catch (e) { /* file:// et sandbox refusent l'ecriture : sans consequence */ }
  }

  /* LE PANNEAU S'AMENE SOUS LA BARRE, ET SEULEMENT S'IL LE FAUT. Defiler a
     chaque bascule serait insupportable au doigt : trois glissements de suite
     feraient trois sauts de page. On ne bouge que si le haut du panneau est
     sorti de la zone de lecture, c'est-a-dire si le visiteur ne le verrait pas
     arriver. */
  function defileVers(id) {
    var s = panneauDe[id];
    if (!s || !s.getBoundingClientRect) return;
    var haut = ligneArrivee();
    var r = s.getBoundingClientRect();
    if (r.top >= haut - 1 && r.top <= window.innerHeight * 0.5) return;
    var y = r.top + (window.pageYOffset || window.scrollY || 0) - haut;
    if (y < 0) y = 0;
    /* `scrollTo` a deux signatures et un navigateur ancien ne connait que la
       premiere : lui passer un objet le ferait defiler a la coordonnee `NaN`,
       c'est-a-dire nulle part. On tente, et on retombe sur les deux nombres. */
    try {
      if (doux) window.scrollTo({ top: y, behavior: 'smooth' });
      else window.scrollTo(0, y);
    } catch (e) { window.scrollTo(0, y); }
  }

  /* La ligne d'arrivee des ancres : `scroll-margin-top`, c'est-a-dire la somme
     de l'en-tete du theme, de la barre et d'une respiration. C'est la feuille
     qui la calcule ; on la lit plutot que de la recalculer, sinon les deux
     auraient diverge au premier reglage. */
  function ligneArrivee() {
    var sm = parseFloat(window.getComputedStyle(sections[0]).scrollMarginTop);
    if (isFinite(sm) && sm > 0) return Math.round(sm);
    var t = parseFloat(window.getComputedStyle(barre).top);
    if (!isFinite(t)) t = 0;
    return Math.round(t + barre.getBoundingClientRect().height);
  }

  /* ── 4. LE JETON SURLIGNE RESTE VISIBLE DANS LA PISTE ────────────────────
     On ne se sert PAS de `scrollIntoView` : il fait defiler tous les ancetres
     scrollables, donc la PAGE, et la page est justement en train de defiler
     sous le doigt du visiteur. On deplace la piste, et rien d'autre.

     LA MARGE DE 12 px EST UNE MARGE DE LISIBILITE : un jeton colle au bord
     laisse croire qu'il est le dernier. */
  function amene(jeton) {
    if (piste.scrollWidth <= piste.clientWidth + 1) return;
    var r = jeton.getBoundingClientRect();
    var p = piste.getBoundingClientRect();
    var d = 0;
    if (r.left < p.left + 12) d = r.left - p.left - 12;
    else if (r.right > p.right - 12) d = r.right - p.right + 12;
    if (!d) return;
    var cible = piste.scrollLeft + d;
    if (doux && piste.scrollTo) piste.scrollTo({ left: cible, behavior: 'smooth' });
    else piste.scrollLeft = cible;
  }

  /* ── 4 bis. LA PISTE DIT DE QUEL COTE ELLE CONTINUE ──────────────────────
     Trois etats, et un quatrieme qui est l'absence d'attribut : au debut, on
     ne voile que la droite ; au bout, on ne voile que la gauche ; au milieu,
     les deux ; et quand tout tient, rien. Le voile est un masque pose par la
     feuille : il ne peint aucun pixel neuf, il ne cache aucun jeton a la
     souris, et il disparait avec le script.

     LA TOLERANCE DE 2 px N'EST PAS UN CONFORT : `scrollLeft` est fractionnaire
     des que le navigateur applique un facteur d'echelle, et un test a l'egalite
     stricte ferait clignoter le voile de droite au bout de la piste. */
  function bords() {
    var reste = piste.scrollWidth - piste.clientWidth;
    if (reste <= 1) { piste.removeAttribute('data-bord'); return; }
    var g = piste.scrollLeft > 2;
    var d = piste.scrollLeft < reste - 2;
    piste.setAttribute('data-bord', g && d ? 'deux' : (g ? 'deb' : 'fin'));
  }
  var bordsEnAttente = false;
  function planifieBords() {
    if (bordsEnAttente) return;
    bordsEnAttente = true;
    window.requestAnimationFrame(function () { bordsEnAttente = false; bords(); });
  }
  piste.addEventListener('scroll', planifieBords, { passive: true });

  /* ── 5. LE CLIC ET LE CLAVIER ────────────────────────────────────────────
     LES ONGLETS RESTENT DES ANCRES : on ne remplace pas le lien, on prend la
     main dessus. Un clic du milieu, un Ctrl+clic ou un « ouvrir dans un nouvel
     onglet » doivent continuer a faire ce qu'ils font partout ailleurs, et
     l'adresse qu'ils emportent (`#gt-salon`) rouvre bien le bon panneau.

     LES FLECHES ACTIVENT EN SE DEPLACANT (activation automatique). C'est la
     forme la plus simple du motif d'onglets et la plus courante : le contenu
     est deja dans la page, il n'y a rien a charger, et demander une seconde
     touche pour valider ferait deux gestes la ou un suffit. */
  function surClic(e) {
    if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.currentTarget;
    var vers = a.getAttribute('data-cmpg-vers');
    if (!vers || !(vers in rang)) return;
    e.preventDefault();
    ouvre(vers, { defile: true });
  }
  for (i = 0; i < jetons.length; i++) jetons[i].addEventListener('click', surClic);
  for (var c in cartes) if (Object.prototype.hasOwnProperty.call(cartes, c)) cartes[c].addEventListener('click', surClic);

  piste.addEventListener('keydown', function (e) {
    var n = rang[courant];
    if (typeof n !== 'number') return;
    var vers = null;
    if (e.key === 'ArrowRight' || e.key === 'Right') vers = ordre[(n + 1) % ordre.length];
    else if (e.key === 'ArrowLeft' || e.key === 'Left') vers = ordre[(n - 1 + ordre.length) % ordre.length];
    else if (e.key === 'Home') vers = ordre[0];
    else if (e.key === 'End') vers = ordre[ordre.length - 1];
    else return;
    e.preventDefault();
    ouvre(vers, { focus: true, defile: false });
  });

  /* L'adresse peut changer sans nous : bouton « precedent » du navigateur, ou
     lien externe vers `#gt-couloir`. Le script en ligne de la section ecoute
     deja `hashchange` et pose les deux attributs ; on refait le tour complet
     (barre, cartes, fleches) pour que tout dise la meme chose. */
  function surAdresse() {
    var m = /^#(?:gt-)?([a-z]+)$/.exec(window.location.hash);
    if (m && m[1] in rang) ouvre(m[1], { adresse: false, defile: false });
  }
  window.addEventListener('hashchange', surAdresse);
  window.addEventListener('popstate', surAdresse);

  /* ══════════════════════════════════════════════════════════════════════
     6. LE GLISSEMENT AU DOIGT
     ----------------------------------------------------------------------
     RETOUR DE RAPH (08/09) : « un effet de slide pour passer d'une piece a
     l'autre, qu'on puisse slider sur mobile, slide style iOS ».

     LE CONFLIT AVEC LE DEFILEMENT VERTICAL N'EST PAS ARBITRE ICI, IL EST
     DECLARE DANS LA FEUILLE. `touch-action: pan-y pinch-zoom` sur le panneau
     dit au navigateur qu'il garde le defilement vertical et le zoom a deux
     doigts, et que l'horizontale nous revient. On ne se bat donc jamais avec
     lui : il n'y a pas de `preventDefault` sur un `touchmove`, pas de seuil a
     deviner, pas de page qui defile pendant qu'un panneau glisse.

     LE GESTE NE PART PAS DE N'IMPORTE OU. Tout ancetre du point de depart qui
     defile lui-meme a l'horizontale (le tableau du recapitulatif, une rangee
     de formats trop longue) garde la main : son defilement est un geste
     lateral aussi, et le lui prendre serait rendre son contenu inatteignable.

     LE SEUIL EST DE 80 px OU D'UNE VITESSE, PAS DES DEUX. Un pouce qui pousse
     franchement franchit la vitesse en trente pixels ; un doigt qui hesite
     doit aller au bout des quatre-vingts. Aux deux bouts de la liste, la
     resistance passe a 0,3 : le panneau bouge un peu, revient, et le visiteur
     comprend qu'il n'y a rien apres sans qu'on lui ecrive.

     LA BASCULE EST IMMEDIATE, ET LE SORTANT NE S'ANIME PAS. On ne peut pas
     faire sortir un panneau qui doit passer en `display: none` a la meme
     image ; et l'animer d'abord, c'est 220 ms d'attente apres un geste qui,
     lui, etait instantane. Le doigt a deja donne le retour : au relachement,
     le panneau reprend sa place et le suivant ENTRE du cote oppose, ce qui
     acheve le mouvement dans le bon sens.

     SOUS MOUVEMENT REDUIT, LE PANNEAU NE SUIT PAS LE DOIGT : le geste reste
     reconnu, le seuil reste le meme, et la bascule est seche. C'est la lettre
     de la demande : « reduced-motion = bascule sans animation ».
     ══════════════════════════════════════════════════════════════════════ */
  if (doigt) (function () {
    var SEUIL = 80;
    var VITESSE = 0.5;
    var VERROU = 10;
    var actif = false;
    var arme = false;
    var vientDeGlisser = false;
    var x0 = 0;
    var y0 = 0;
    var t0 = 0;
    var dx = 0;
    var cible = null;

    function panneau() { return panneauDe[courant] || null; }

    /* DEUX FAMILLES DE DEPARTS NOUS SONT INTERDITES, ET POUR DEUX RAISONS
       DIFFERENTES.

       1. TOUT ANCETRE QUI DEFILE LUI-MEME A L'HORIZONTALE garde la main : son
          defilement lateral est un geste lateral aussi, et le lui prendre
          rendrait son contenu inatteignable.
       2. TOUT CHAMP DE SAISIE (revue G18e). Dans le champ « longueur de votre
          couloir », un doigt qui traine SELECTIONNE du texte ou deplace le
          curseur : c'est un geste horizontal qui appartient au champ, pas a la
          page. Sans cette garde, corriger « 3,50 » en « 3,05 » changeait de
          piece. `select` et `textarea` suivent la meme regle, et
          `contenteditable` avec eux : la page n'en porte aucun aujourd'hui, et
          le jour ou elle en portera un, la garde sera deja la. */
    var CHAMPS = { INPUT: 1, SELECT: 1, TEXTAREA: 1 };
    function bloque(el) {
      var p = panneau();
      for (var n = el; n && n !== p && n !== document.body; n = n.parentNode) {
        if (n.nodeType !== 1) continue;
        if (CHAMPS[n.tagName]) return true;
        if (n.isContentEditable) return true;
        if (n.scrollWidth && n.clientWidth && n.scrollWidth > n.clientWidth + 2) return true;
      }
      return false;
    }

    function surBas(e) {
      /* LE DRAPEAU SE DESARME AUSSI ICI, ET C'EST LA MOITIE DE LA CORRECTION.
         Un geste qui ne produit AUCUN clic (le doigt sort du panneau, le
         navigateur avale l'evenement, un `pointercancel` arrive) laissait le
         drapeau arme pour toujours : le prochain vrai clic, celui d'un
         visiteur qui touche « Voir les tapis », etait alors mange. On le
         desarme au debut de chaque geste, en plus du desarmement differe. */
      vientDeGlisser = false;
      if (e.pointerType === 'mouse' || !e.isPrimary) return;
      var p = panneau();
      if (!p || !p.contains(e.target) || bloque(e.target)) return;
      actif = true; arme = false; dx = 0; cible = p;
      x0 = e.clientX; y0 = e.clientY; t0 = e.timeStamp || Date.now();
    }

    function surBouge(e) {
      if (!actif) return;
      var ex = e.clientX - x0;
      var ey = e.clientY - y0;
      if (!arme) {
        /* L'AXE SE DECIDE UNE FOIS, ET NE SE REDISCUTE PLUS. Un geste qui
           part a la verticale reste vertical jusqu'au relachement, meme s'il
           derive : sans cette memoire, un defilement un peu penche
           attraperait le panneau au milieu de sa course. */
        if (Math.abs(ey) > VERROU && Math.abs(ey) >= Math.abs(ex)) { actif = false; return; }
        if (Math.abs(ex) < VERROU) return;
        arme = true;
        racine.classList.add('cmpg-glisse');
        if (cible) cible.classList.remove('is-retour');
      }
      dx = ex;
      if (!doux || !cible) return;
      var n = rang[courant];
      var mur = (dx < 0 && n >= ordre.length - 1) || (dx > 0 && n <= 0);
      cible.style.transform = 'translateX(' + (mur ? dx * 0.3 : dx).toFixed(1) + 'px)';
    }

    function surHaut(e) {
      if (!actif) return;
      var etait = arme;
      var d = dx;
      var ms = Math.max(1, (e.timeStamp || Date.now()) - t0);
      actif = false; arme = false; dx = 0;
      racine.classList.remove('cmpg-glisse');
      if (!etait) { cible = null; return; }
      /* LE DRAPEAU NE SURVIT PAS AU TOUR DE BOUCLE. Le `click` qui termine un
         geste, s'il vient, arrive dans la meme tache que le `pointerup` ou
         juste apres : un `setTimeout(0)` passe donc APRES lui, jamais avant.
         Si aucun clic ne vient, le drapeau tombe tout seul au lieu de rester
         arme jusqu'au prochain geste. C'est la seconde moitie de la correction
         de revue : sans elle, un glissement sans clic mangeait le clic
         suivant, celui d'un visiteur qui touche « Voir les tapis ». */
      vientDeGlisser = true;
      window.setTimeout(function () { vientDeGlisser = false; }, 0);

      var n = rang[courant];
      var franchi = Math.abs(d) >= SEUIL || Math.abs(d) / ms >= VITESSE;
      var vers = null;
      if (franchi && d < 0 && n < ordre.length - 1) vers = ordre[n + 1];
      else if (franchi && d > 0 && n > 0) vers = ordre[n - 1];

      var sortant = cible;
      cible = null;
      if (vers) {
        /* Le sortant reprend sa place SANS transition : il va disparaitre a
           l'image suivante, et une transition sur un noeud qui passe en
           `display: none` ne se voit pas, elle se paie. */
        if (sortant) { sortant.classList.remove('is-retour'); sortant.style.transform = ''; }
        ouvre(vers, { sens: d < 0 ? 'av' : 'ar', defile: true });
        return;
      }
      if (!sortant || !doux) { if (sortant) sortant.style.transform = ''; return; }
      /* LE RETOUR ELASTIQUE. On repose la transition, on remet a zero, et on
         retire la classe quand le mouvement est fini : la laisser poserait une
         transition permanente sur un panneau qui, le reste du temps, ne doit
         pas en avoir. */
      sortant.classList.add('is-retour');
      sortant.style.transform = '';
      var fin = function () {
        sortant.classList.remove('is-retour');
        sortant.removeEventListener('transitionend', fin);
      };
      sortant.addEventListener('transitionend', fin);
      window.setTimeout(fin, 600);
    }

    if (window.PointerEvent) {
      document.addEventListener('pointerdown', surBas, { passive: true });
      document.addEventListener('pointermove', surBouge, { passive: true });
      document.addEventListener('pointerup', surHaut, { passive: true });
      document.addEventListener('pointercancel', function () {
        if (!actif) return;
        actif = false; arme = false; dx = 0;
        vientDeGlisser = false;
        racine.classList.remove('cmpg-glisse');
        if (cible) { cible.style.transform = ''; cible = null; }
      }, { passive: true });
    }

    /* UN GLISSEMENT NE DOIT PAS FINIR EN CLIC. Le doigt s'est arrete sur une
       pastille de format, et le navigateur emet un `click` a la fin du geste :
       sans cette garde, changer de piece changerait aussi le format de la
       piece qu'on quitte.

       LE DRAPEAU N'EST PAS LA CLASSE `cmpg-glisse`, ET C'EST UNE CORRECTION.
       Cette classe est retiree au relachement, c'est-a-dire AVANT que le
       navigateur emette son `click` : la garde ne se serait jamais declenchee.
       Un drapeau a part, remis a faux au premier clic quel qu'il soit, annule
       exactement UN clic, celui qui termine le geste, et pas un de plus. */
    document.addEventListener('click', function (e) {
      if (!vientDeGlisser) return;
      vientDeGlisser = false;
      e.preventDefault();
      e.stopPropagation();
    }, true);
  })();

  /* ── 7. LE TEMOIN DE COLLAGE ─────────────────────────────────────────────
     Pose par le script et non par le Liquid : il ne peint rien, ne prend
     aucune place, sort de l'arbre d'accessibilite, et il est eprouve en local
     par `.impeccable/tools/g14-page.mjs` avant tout push. L'etat vit sur
     `<html>` parce que c'est le seul noeud qu'aucun rendu partiel ne
     remplace. */
  var temoin = document.createElement('div');
  temoin.className = 'cmpg-temoin';
  temoin.setAttribute('aria-hidden', 'true');
  temoin.style.cssText = 'display:block;height:0;margin:0;padding:0;border:0;pointer-events:none;';
  if (barre.parentNode) barre.parentNode.insertBefore(temoin, barre);

  var enAttente = false;
  function image() {
    enAttente = false;
    var t = parseFloat(window.getComputedStyle(barre).top);
    if (!isFinite(t)) t = 0;
    racine.classList.toggle('cmpg-collee', temoin.getBoundingClientRect().top <= t + 1);
  }
  function planifie() {
    if (enAttente) return;
    enAttente = true;
    window.requestAnimationFrame(image);
  }

  window.addEventListener('scroll', planifie, { passive: true });
  window.addEventListener('resize', function () { planifie(); bords(); somAccorde(); }, { passive: true });

  /* `header.js` bascule `header-pinned` dans SA propre image : selon l'ordre
     des ecouteurs, la notre peut passer juste avant la sienne et lire l'etat
     d'avant. On reagit donc aussi au changement de classe du corps, ce qui
     rend la synchronisation exacte au lieu d'exacte a une image pres. */
  if (window.MutationObserver) {
    new MutationObserver(planifie).observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  /* ── 8. LA GRILLE DE CHOIX SUIT LA LARGEUR, PAS LE VISITEUR ─────────────
     LE PREMIER ETAT N'EST PAS POSE ICI, ET C'EST LE POINT (fix round 2 de
     G15). La grille est rendue OUVERTE par le serveur et refermee sous
     1024 px par le script en ligne de la section, PENDANT l'analyse du
     document. Poser cet etat depuis ce fichier, charge en `defer`, le posait
     APRES la premiere peinture : un decalage de mise en page pour rien.

     CE QUI RESTE ICI est ce qui ne peut pas etre ecrit dans le document :
     suivre les changements de largeur, et s'arreter des que le visiteur y a
     touche. Une grille qu'on referme et qui se rouvre au premier
     redimensionnement se bat contre son lecteur.

     ON ECOUTE LE CLIC SUR LE RESUME, PAS L'EVENEMENT `toggle`. Un `toggle`
     part de facon asynchrone et ne dit pas QUI a change l'etat : celui que les
     lignes en ligne declenchent pouvait arriver apres l'ecouteur et passer
     pour un geste du visiteur, ce qui gelait le suivi de largeur pour le reste
     de la visite. Un `click` sur le `<summary>`, lui, ne peut venir que d'une
     souris, d'un doigt ou d'une touche : une ecriture programmee n'en produit
     pas. */
  var som = document.querySelector('[data-cmpg-som]');
  var somTouche = false;

  function somAccorde() {
    if (!som || somTouche) return;
    var veut = window.innerWidth >= 1024;
    if (som.open !== veut) som.open = veut;
  }
  if (som) {
    var somResume = som.querySelector('summary');
    if (somResume) somResume.addEventListener('click', function () { somTouche = true; });
  }

  /* ── 9. A L'IMPRESSION, LES REPLIS S'OUVRENT ────────────────────────────
     ET CA NE PEUT PAS SE FAIRE EN CSS. Le contenu d'un `<details>` ferme n'est
     pas cache par une regle de style : il n'est pas distribue du tout, et
     aucun `display` d'auteur ne le revele. Il faut poser l'attribut `open`.
     Les ONZE PANNEAUX, eux, reviennent bien par la feuille (§ « SUR DU PAPIER,
     LES ONZE TYPES REVIENNENT ») : un panneau cache l'est par `display`, et un
     `display` se renverse.

     ON REPOSE L'ETAT D'AVANT APRES L'IMPRESSION, un repli a la fois : un
     visiteur qui avait deroule le recapitulatif et imprime la page le retrouve
     deroule, un visiteur qui ne l'avait pas ouvert le retrouve ferme. Une
     impression ne doit rien changer a l'ecran.

     LES DEUX CHEMINS SONT ECOUTES : `beforeprint` / `afterprint`, et la
     requete de media `print`, que Safari est seul a suivre de facon fiable. Un
     navigateur qui declenche les deux ne fait que reposer deux fois le meme
     etat. */
  var repliMemo = null;
  function replis(ouvreLes) {
    var d = document.querySelectorAll('details.cmpg-repli');
    if (ouvreLes) {
      /* Deja memorise : on ne re-memorise PAS, sinon un second `beforeprint`
         (le navigateur peut basculer la requete de media ET emettre
         l'evenement) enregistrerait l'etat DEPLIE comme etat a restaurer, et
         les replis resteraient ouverts apres l'impression. */
      if (repliMemo) return;
      repliMemo = [];
      for (var a = 0; a < d.length; a++) { repliMemo.push(d[a].open); d[a].open = true; }
      return;
    }
    if (!repliMemo) return;
    for (var b = 0; b < d.length && b < repliMemo.length; b++) d[b].open = repliMemo[b];
    repliMemo = null;
  }
  window.addEventListener('beforeprint', function () { replis(true); });
  window.addEventListener('afterprint', function () { replis(false); });
  if (window.matchMedia) {
    var mq = window.matchMedia('print');
    var surPrint = function (e) { replis(e.matches); };
    if (mq.addEventListener) mq.addEventListener('change', surPrint);
    else if (mq.addListener) mq.addListener(surPrint);
  }

  /* LE PREMIER TOUR NE TOUCHE NI A L'ADRESSE NI AU DEFILEMENT : la page vient
     d'arriver a l'endroit que le visiteur a demande, et l'y renvoyer serait un
     saut gratuit. Il ne fait que dire a la barre, aux cartes et aux fleches ce
     que la feuille montre deja. */
  ouvre(courant, { adresse: false, defile: false });
  planifie();
  bords();
})();
